var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "868.32 317 617.539 654.322",
    width: "617.539pt",
    height: "654.322pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_4W2RjKYU07HES9edFtrMjVRvlz4gzEJx"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 868.32,
    y: 317,
    width: 617.539,
    height: 654.322
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_4W2RjKYU07HES9edFtrMjVRvlz4gzEJx)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 1383.257 517.076 C 1354.019 495.219 1308.225 474.547 1257.617 460.363 C 1211.539 447.447 1166.596 441.212 1131.057 442.804 L 1130.872 438.671 C 1166.834 437.061 1212.244 443.348 1258.734 456.379 C 1309.813 470.696 1356.103 491.612 1385.734 513.763 L 1383.257 517.076 Z ",
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1380.221 533.913 C 1380.247 553.278 1376.187 572.432 1368.307 590.121 Q 1367.32 592.343 1366.251 594.523 C 1338.026 652.333 1273.644 683.021 1210.962 668.541 C 1148.281 654.061 1103.882 598.245 1103.872 533.913 Q 1103.872 529.116 1104.199 524.393 Q 1104.354 521.992 1104.6 519.619 C 1112.21 446.483 1175.763 392.115 1249.196 395.924 C 1322.629 399.732 1380.218 460.381 1380.221 533.913 L 1380.221 533.913 Z ",
    fill: "rgb(0,141,73)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 1368.307 590.121 Q 1367.32 592.343 1366.251 594.523 Q 1360.194 595.181 1353.501 595.479 C 1349.806 595.644 1346.004 595.727 1342.12 595.727 C 1308.189 595.727 1267.353 589.464 1225.635 577.773 C 1179.144 564.741 1137.084 546.514 1107.198 526.445 Q 1105.672 525.421 1104.199 524.393 Q 1104.354 521.992 1104.6 519.619 Q 1106.977 521.313 1109.503 523.012 C 1139.036 542.84 1180.675 560.873 1226.752 573.789 C 1268.105 585.381 1308.557 591.59 1342.099 591.59 Q 1347.852 591.59 1353.315 591.346 Q 1361.27 590.986 1368.307 590.121 Z ",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: " M 1342.12 592.418 C 1308.19 592.419 1267.352 586.155 1225.636 574.463 C 1179.146 561.432 1137.083 543.204 1107.198 523.136 C 1076.688 502.65 1062.382 482.463 1066.914 466.295 C 1071.445 450.127 1094.159 440.316 1130.872 438.671 L 1131.057 442.804 C 1113.913 443.572 1099.941 446.121 1089.529 450.378 C 1079.143 454.625 1072.874 460.356 1070.897 467.412 C 1068.919 474.467 1071.296 482.621 1077.962 491.648 C 1084.644 500.696 1095.256 510.135 1109.504 519.702 C 1139.034 539.531 1180.674 557.564 1226.753 570.479 C 1268.107 582.07 1308.555 588.281 1342.1 588.282 Q 1347.849 588.282 1353.313 588.038 C 1370.458 587.269 1384.43 584.721 1394.841 580.464 C 1405.227 576.217 1411.496 570.486 1413.474 563.43 C 1417.024 550.761 1406.293 534.299 1383.257 517.076 L 1385.734 513.763 C 1397.588 522.626 1406.364 531.362 1411.816 539.728 C 1417.661 548.697 1419.559 557.048 1417.457 564.547 C 1412.925 580.715 1390.211 590.525 1353.499 592.171 C 1349.804 592.336 1346.005 592.418 1342.12 592.418 Z ",
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1245.7020099999975,
    cy: 369.234829999999,
    r: 1.5833500000001095,
    fill: "rgb(242,242,242)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1035.64502,
    cy: 436.80077999999986,
    r: 2.723899999999958,
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1029.83942,
    cy: 543.4126199999997,
    r: 5.38101000000006,
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1352.84163,
    cy: 378.73489,
    r: 3.586309999999912,
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1480.03694,
    cy: 527.57918,
    r: 5.822779999999966,
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1434.5056799999968,
    cy: 434.57998999999916,
    r: 2.498239999999896,
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1131.1734600000004,
    cy: 402.4850600000002,
    r: 3.897330000000011,
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1425.7618499999974,
    cy: 515.7723899999994,
    r: 2.498239999999896,
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1042.5061799999999,
    cy: 619.4131600000001,
    r: 3.109390000000076,
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1105.31216,
    cy: 662.69122,
    r: 3.3672899999999117,
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1203.2 323.645 L 1196.555 323.645 L 1196.555 317 L 1192.99 317 L 1192.99 323.645 L 1186.342 323.645 L 1186.342 327.213 L 1192.99 327.213 L 1192.99 333.858 L 1196.555 333.858 L 1196.555 327.213 L 1203.2 327.213 L 1203.2 323.645 L 1203.2 323.645 Z ",
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1357.342 683.201 L 1353.168 683.201 L 1353.168 679.029 L 1350.93 679.029 L 1350.93 683.201 L 1346.758 683.201 L 1346.758 685.44 L 1350.93 685.44 L 1350.93 689.612 L 1353.168 689.612 L 1353.168 685.44 L 1357.342 685.44 L 1357.342 683.201 L 1357.342 683.201 Z ",
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1453.646 661.844 L 1450.527 661.844 L 1450.527 658.725 L 1448.852 658.725 L 1448.852 661.844 L 1445.733 661.844 L 1445.733 663.519 L 1448.852 663.519 L 1448.852 666.638 L 1450.527 666.638 L 1450.527 663.519 L 1453.646 663.519 L 1453.646 661.844 L 1453.646 661.844 Z ",
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1244.1187,
    cy: 425.71736999999956,
    r: 11.611190000000079,
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1154.92363,
    cy: 510.6901699999999,
    r: 11.611190000000079,
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1283.17451,
    cy: 627.32987,
    r: 11.611190000000079,
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1244.1187,
    cy: 528.6347499999999,
    r: 11.611190000000079,
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1160.72921,
    cy: 592.49629,
    r: 11.611190000000079,
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1306.3969,
    cy: 466.3565399999995,
    r: 11.611190000000079,
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1344.92492,
    cy: 544.9959699999999,
    r: 11.611190000000079,
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1244.1187,
    cy: 477.96774000000016,
    r: 15.305669999999964,
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1244.119 455.801 C 1238.38 455.801 1232.876 458.081 1228.818 462.139 C 1224.76 466.197 1222.48 471.701 1222.48 477.44 C 1222.48 489.391 1244.119 528.635 1244.119 528.635 C 1244.119 528.635 1265.758 489.391 1265.758 477.44 C 1265.758 471.701 1263.478 466.197 1259.42 462.139 C 1255.362 458.081 1249.858 455.801 1244.119 455.801 L 1244.119 455.801 Z  M 1244.119 487.996 C 1238.58 487.996 1234.091 483.506 1234.091 477.968 C 1234.091 472.429 1238.58 467.94 1244.119 467.94 C 1249.657 467.94 1254.147 472.429 1254.147 477.968 C 1254.147 480.627 1253.09 483.178 1251.21 485.058 C 1249.329 486.939 1246.778 487.996 1244.119 487.996 L 1244.119 487.996 Z ",
    fill: "rgb(58,65,72)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1160.7292099999997,
    cy: 543.4126200000001,
    r: 15.305650000000014,
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1160.729 521.246 C 1154.99 521.246 1149.486 523.526 1145.428 527.584 C 1141.37 531.642 1139.09 537.146 1139.09 542.885 C 1139.09 554.836 1160.729 594.08 1160.729 594.08 C 1160.729 594.08 1182.368 554.836 1182.368 542.885 C 1182.368 537.146 1180.088 531.642 1176.03 527.584 C 1171.972 523.526 1166.468 521.246 1160.729 521.246 L 1160.729 521.246 Z  M 1160.729 553.44 C 1155.191 553.44 1150.701 548.951 1150.701 543.413 C 1150.701 537.874 1155.191 533.385 1160.729 533.385 C 1166.268 533.385 1170.757 537.874 1170.757 543.413 C 1170.757 546.072 1169.701 548.623 1167.82 550.503 C 1165.939 552.384 1163.389 553.44 1160.729 553.44 L 1160.729 553.44 Z ",
    fill: "rgb(58,65,72)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1344.92492,
    cy: 495.9123000000002,
    r: 15.305669999999964,
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1344.925 473.745 C 1339.186 473.745 1333.682 476.025 1329.624 480.083 C 1325.566 484.142 1323.286 489.646 1323.286 495.385 C 1323.286 507.335 1344.925 546.579 1344.925 546.579 C 1344.925 546.579 1366.564 507.335 1366.564 495.385 C 1366.564 489.646 1364.284 484.142 1360.226 480.083 C 1356.168 476.025 1350.664 473.745 1344.925 473.745 L 1344.925 473.745 Z  M 1344.925 505.94 C 1339.387 505.94 1334.897 501.45 1334.897 495.912 C 1334.897 490.374 1339.387 485.884 1344.925 485.884 C 1350.463 485.884 1354.953 490.374 1354.953 495.912 C 1354.953 498.572 1353.896 501.122 1352.016 503.003 C 1350.135 504.884 1347.585 505.94 1344.925 505.94 L 1344.925 505.94 Z ",
    fill: "rgb(58,65,72)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1244.1187,
    cy: 375.0503500000001,
    r: 15.305669999999964,
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1244.119 352.884 C 1232.168 352.884 1222.48 362.572 1222.48 374.523 C 1222.48 386.473 1244.119 425.717 1244.119 425.717 C 1244.119 425.717 1265.758 386.473 1265.758 374.523 C 1265.758 368.784 1263.478 363.28 1259.42 359.221 C 1255.362 355.163 1249.858 352.884 1244.119 352.884 L 1244.119 352.884 Z  M 1244.119 385.078 C 1238.58 385.078 1234.091 380.589 1234.091 375.05 C 1234.091 369.512 1238.58 365.022 1244.119 365.022 C 1249.657 365.022 1254.147 369.512 1254.147 375.05 C 1254.147 377.71 1253.09 380.261 1251.21 382.141 C 1249.329 384.022 1246.778 385.078 1244.119 385.078 L 1244.119 385.078 Z ",
    fill: "rgb(58,65,72)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1283.1745100000003,
    cy: 578.2462000000002,
    r: 15.305669999999964,
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1283.174 556.079 C 1277.435 556.079 1271.932 558.359 1267.873 562.417 C 1263.815 566.475 1261.536 571.979 1261.536 577.718 C 1261.536 589.669 1283.174 628.913 1283.174 628.913 C 1283.174 628.913 1304.814 589.669 1304.814 577.718 C 1304.814 571.979 1302.534 566.475 1298.476 562.417 C 1294.417 558.359 1288.914 556.079 1283.174 556.079 Z  M 1283.174 588.274 C 1277.636 588.274 1273.147 583.784 1273.147 578.246 C 1273.147 572.708 1277.636 568.218 1283.175 568.218 C 1288.713 568.218 1293.202 572.708 1293.202 578.246 C 1293.202 580.906 1292.146 583.456 1290.265 585.337 C 1288.385 587.218 1285.834 588.274 1283.174 588.274 L 1283.174 588.274 Z ",
    fill: "rgb(62,117,232)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1154.9236300000005,
    cy: 460.5509400000001,
    r: 15.305669999999964,
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1154.924 438.384 C 1149.185 438.384 1143.681 440.664 1139.623 444.722 C 1135.564 448.78 1133.285 454.284 1133.285 460.023 C 1133.285 471.974 1154.924 511.218 1154.924 511.218 C 1154.924 511.218 1176.563 471.974 1176.563 460.023 C 1176.563 454.284 1174.283 448.78 1170.225 444.722 C 1166.167 440.664 1160.663 438.384 1154.924 438.384 L 1154.924 438.384 Z  M 1154.924 470.579 C 1149.385 470.579 1144.896 466.089 1144.896 460.551 C 1144.896 455.013 1149.385 450.523 1154.924 450.523 C 1160.462 450.523 1164.952 455.013 1164.952 460.551 C 1164.952 463.21 1163.895 465.761 1162.014 467.642 C 1160.134 469.522 1157.583 470.579 1154.924 470.579 L 1154.924 470.579 Z ",
    fill: "rgb(62,117,232)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1306.3969000000004,
    cy: 417.80065000000013,
    r: 15.305669999999964,
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1306.397 395.634 C 1300.658 395.634 1295.154 397.914 1291.096 401.972 C 1287.038 406.03 1284.758 411.534 1284.758 417.273 C 1284.758 429.224 1306.397 468.468 1306.397 468.468 C 1306.397 468.468 1328.036 429.224 1328.036 417.273 C 1328.036 405.322 1318.348 395.634 1306.397 395.634 L 1306.397 395.634 Z  M 1306.397 427.829 C 1300.859 427.829 1296.369 423.339 1296.369 417.801 C 1296.369 412.262 1300.859 407.773 1306.397 407.773 C 1311.935 407.773 1316.425 412.262 1316.425 417.801 C 1316.425 423.339 1311.935 427.829 1306.397 427.829 L 1306.397 427.829 L 1306.397 427.829 Z ",
    fill: "rgb(62,117,232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1040.862 959.715 L 1053.044 958.332 L 1053.509 910.688 L 1035.53 912.729 L 1040.862 959.715 L 1040.862 959.715 Z ",
    fill: "rgb(255,184,184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1077.82 966.978 L 1039.535 971.322 L 1037.857 956.53 L 1061.35 953.865 C 1069.519 952.938 1076.893 958.809 1077.82 966.978 L 1077.82 966.978 L 1077.82 966.978 Z ",
    fill: "rgb(81,79,125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 915.582 958.954 L 927.842 958.953 L 933.674 911.665 L 915.58 911.666 L 915.582 958.954 L 915.582 958.954 Z ",
    fill: "rgb(255,184,184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 951.486 970.336 L 912.956 970.338 L 912.955 955.451 L 936.599 955.45 C 944.821 955.45 951.486 962.115 951.486 970.336 L 951.486 970.336 L 951.486 970.336 Z ",
    fill: "rgb(81,79,125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1003.544 747.486 L 1010.544 770.255 L 1048.544 852.486 L 1058.544 930.486 L 1035.544 931.486 L 1021.544 859.486 L 973.544 807.486 L 931.544 943.486 L 912.544 941.486 C 912.544 941.486 928.544 765.486 950.544 747.486 C 950.544 747.486 986.544 730.486 1003.544 747.486 Z ",
    fill: "rgb(62,117,232)"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 972.4923699999996,
    cy: 624.6788999999997,
    r: 24.56102999999996,
    fill: "rgb(255,184,184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1006.044 751.986 C 1006.044 751.986 1009.044 649.986 967.044 656.986 C 967.044 656.986 942.544 762.486 942.544 762.486 C 942.544 762.486 951.544 780.486 973.544 760.486 C 995.544 740.486 1006.044 751.986 1006.044 751.986 Z ",
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 948.044 699.986 L 957.927 737.869 L 972.984 752.927 L 952.044 745.986 L 948.044 699.986 L 948.044 699.986 Z ",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: " M 1006.354 795.124 C 1003.556 794.11 1001.351 791.908 1000.333 789.112 C 999.314 786.316 999.587 783.212 1001.077 780.636 L 977.718 753.593 L 996.132 751.196 L 1015.491 777.244 C 1019.746 780.097 1021.195 785.681 1018.864 790.243 C 1016.533 794.804 1011.159 796.902 1006.354 795.124 L 1006.354 795.124 Z ",
    fill: "rgb(255,184,184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 977.914 677.762 L 980.544 729.486 L 1011.544 769.486 L 998.544 779.486 L 956.544 737.486 C 956.544 737.486 941.544 686.486 952.544 671.486 C 956.669 665.861 961.215 664.314 965.288 664.578 C 972.221 665.155 977.636 670.81 977.914 677.762 Z ",
    fill: "rgb(204,204,204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 969.571 650.486 C 969.809 650.273 969.933 649.96 969.904 649.642 C 969.876 649.324 969.7 649.038 969.428 648.87 C 964.985 646.118 962.4 641.16 962.687 635.942 C 962.973 630.725 966.087 626.08 970.804 623.832 C 978.025 620.389 987.81 623.068 993.148 616.452 C 995.345 613.587 996.186 609.909 995.451 606.375 C 994.299 600.126 989.602 595.485 984.341 592.305 C 971.157 584.335 954.589 584.551 941.617 592.861 C 928.645 601.171 921.523 616.131 923.252 631.439 C 923.931 637.453 925.786 644.197 922.21 649.08 C 919.063 653.377 913.122 654.183 907.904 655.251 C 896.71 657.541 885.912 662.825 878.316 671.359 C 870.72 679.894 866.668 691.868 868.958 703.061 C 871.248 714.254 880.436 724.091 891.729 725.826 C 900.92 727.238 910.411 723.334 917.161 716.938 C 923.911 710.541 928.178 701.902 930.869 693.001 C 934.063 682.435 935.323 671.05 941.09 661.639 C 946.733 652.429 958.894 645.827 968.425 650.623 C 968.798 650.819 969.254 650.764 969.571 650.486 L 969.571 650.486 Z ",
    fill: "rgb(47,46,65)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIllustration);
export default __webpack_public_path__ + "static/media/home-illustration.4941e970.svg";
export { ForwardRef as ReactComponent };